import axios from "axios";
import store from "../store";
import { tokenExpirado, redirectLoginExpirado } from "../utils/jwt";
import interceptorCaseRequest from "./interceptorCaseService";

/**
 * Central axios instance for all authenticated API calls in the front app.
 *
 * - JWT token is read per-call (never at module scope) to avoid stale tokens after re-login.
 * - baseURL is resolved per-call too: when the browser goes offline, requests are routed
 *   to the local backend (offline mode used by the POS). See utils/conectividad.js.
 * - X-Empresa-Cliente header is set from the parsed user token object.
 * - 401 responses dispatch user/logout via Vuex store (clean state reset).
 *
 * All new services and Vuex actions MUST import this instance.
 * Do NOT use raw axios for authenticated calls.
 */
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
});

http.interceptors.request.use(interceptorCaseRequest);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const esLogin = error.config?.url?.includes("/auth/");
      if (!esLogin && tokenExpirado()) {
        store.commit("logout");
        redirectLoginExpirado();
        return;
      }
    }
    return Promise.reject(error);
  }
);

export default http;
